import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padGptStock/page`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findDetails({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padGptStock/selectBillFlowList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCustomerName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/padGptStock/findUserById', {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/padGptStock/save', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
